export enum FileExtension {
  XLSX = 'xlsx',
  CSV = 'csv',
  JSON = 'json',
}
